<template>
  <v-container
    id="wizard"
    tag="section"
  >
    <validation-observer v-slot="{ valid }">
      <base-reset-material-wizard
        v-model="tab"
        :available-steps="availableSteps"
        :items="tabs"
        class="mx-auto"
        @click:next="resetPassword(valid)"
        @click:prev="$emit('click:prev')"
        :loading="loading"
      >
        <v-tab-item class="pb-1">
          <form>
            <v-row
              class="mx-auto"
              justify="space-around"
            >
              <v-col
                cols="12"
                md="11"
              >
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="email"
                >
                  <v-text-field
                    v-model="email"
                    :error-messages="errors"
                    color="primary"
                    label="Email*"
                    prepend-icon="mdi-email"
                    validate-on-blur
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </form>
        </v-tab-item>
      </base-reset-material-wizard>
    </validation-observer>
  </v-container>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  components: {
    BaseResetMaterialWizard: () => import("@/components/login/base/BaseResetMaterialWizard")
  },

  data: () => ({
    logged: false,
    email: '',
    password: '',
    tab: 0,
    tabs: ['Resetar Senha'],
    empresa: '',
    profilePic: null,
    loading: false
  }),

  computed: {
    availableSteps () {
      const steps = [0]
      return steps
    },
  },

  methods: {
    async resetPassword (valid) {
      if (!valid){
        this.$toast.error('Preencha o campo de Email','',{position: 'topRight'});
        return
      }
      this.loading = true;

      firebase
      .auth()
      .sendPasswordResetEmail(this.email)
      .then(() => {
        this.$toast.success('Email enviado com sucesso','',{position: 'topRight'});
      })
      .catch(error => {
        this.$toast.error('Falha ao enviar Email','',{position: 'topRight'});
      })
      .finally(() => this.loading = false);
    }
  }
}
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%
</style>
